/* v8 ignore start */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WizardLandingPage from './components/WizardLandingPage';
import WizardPathOne from './components/WizardPathOne';
import WizardPathTwo from './components/WizardPathTwo';
import WizardPathThree from './components/WizardPathThree';
import * as actions from './ComplexWizard.slice';

const mapStateToProps = (
  (state) => ({
    wizardStore: state.ComplexWizard || {},
    selectedPath: state.ComplexWizard.selectedPath
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class ComplexWizard extends Component {

  // TODO: Update logic when migrating to React 17
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.handleOpen();
  }

  render() {
    const props = this.props;
    const { selectedPath } = props;
    switch (selectedPath) {
      case 1:
        return <WizardPathOne  {...props}  />;
      case 2:
        return <WizardPathTwo  {...props} />;
      case 3:
        return <WizardPathThree  {...props} />;
      default:
        return <WizardLandingPage  {...props} />;
    }
  }
}

ComplexWizard.propTypes = {
  handleOpen: PropTypes.func
};

export default connect(mapStateToProps, actions, mergeProps)(ComplexWizard);
